import { useEffect, useState } from "react";

import HttpError from "../interfaces/api/http-error";
import ValidationResult, { isValidationResultArray } from "../interfaces/api/validation-result";

interface EffectOptions {
  postError?: ValidationResult[] | HttpError | null;
  patchError?: ValidationResult[] | HttpError | null;
  resetPostHandler?: () => void;
  resetPatchHandler?: () => void;
}

const useServerValidationResponseEffect = ({
  postError,
  patchError,
  resetPostHandler,
  resetPatchHandler,
}: EffectOptions) => {
  const [serverValidationErrors, setServerValidationErrors] = useState<ValidationResult[]>(
    isValidationResultArray(postError) && postError.length > 0
      ? postError
      : isValidationResultArray(patchError) && patchError.length > 0
      ? patchError
      : []
  );
  const [resetToggle, setResetToggle] = useState(false);

  useEffect(() => {
    if (isValidationResultArray(postError)) {
      setServerValidationErrors([...postError]);
      if (resetPostHandler != null) {
        resetPostHandler();
      }
    } else if (isValidationResultArray(patchError)) {
      setServerValidationErrors([...patchError]);
      if (resetPatchHandler != null) {
        resetPatchHandler();
      }
    }
  }, [patchError, postError, resetPatchHandler, resetPostHandler]);

  const removeServerError = (inputKey: string) => {
    setServerValidationErrors((prevState) =>
      prevState.filter((sv) => !(sv.inputKey !== undefined && sv.inputKey === inputKey))
    );
  };

  const getServerValidationResultOrNull = (inputKey: string) => {
    let serverValidation = serverValidationErrors.find((sv) => sv.inputKey === inputKey);
    return serverValidation !== undefined ? serverValidation : null;
  };

  const updateResetToggle = () => {
    setResetToggle((prevState) => !prevState);
  };

  return { resetToggle, updateResetToggle, removeServerError, getServerValidationResultOrNull };
};

export default useServerValidationResponseEffect;
